export const userDetails = {
  _id: "61d7fd3f38feb03c8c1a34c2",
  username: "RS02",
  sfname: "Rishabh",
  slname: "Jain", // added
  licence_issue_date: "22-01-2021", // added
  licence_no: "lc_1234", // added
  office_city: "Gurugram", // added
  gen: "Male",
  ecode: "RS02",
  doj: 1641531600,
  dact_dt: null,
  strcode: null,
  email: "rishabh.jain@niit.com",
  mcode: "1",
  fmcode: null,
  mbl: "9999999999",
  bus_role: "ASM",
  bus_status: null,
  degn: "Manager",
  rgn: "ALL",
  dept: "Global",
  crtfct_typ: "Daikin-Certificate",
  role: "student",
  isAccepted: true,
  show: {
    shw_notification: 1,
    shw_rating: 1,
    shw_post_rating: 1,
    shw_calendar: 1,
    shw_courses: 1,
    shw_exam: 1,
    shw_crs_detail: 1,
    shw_crs_resourse_tab: 1,
    shw_crs_recording_tab: 1,
    shw_crs_share: 0,
    shw_recording_share: 1,
    shw_exclude_btn: 1,
    shw_crs_edit: 1,
    shw_crs_exclude: 1,
  },
};

export const roleServingList = {
  status: "true",
  token: "76df784b-b321-464c-bf94-d28174710cef",
  data: {
    team_lead: [
      {
        _id: 2223,
        first_name: "Shradesh",
        last_name: "P",
        username: "shradesh-9@mailinator.com",
        email: "shradesh-9@mailinator.com",
      },
    ],
    mentor: [
      {
        _id: 2223,
        first_name: "Shradesh",
        last_name: "P",
        username: "shradesh-9@mailinator.com",
        email: "shradesh-9@mailinator.com",
      },
    ],
    coach: [
      {
        _id: 2223,
        first_name: "Shradesh",
        last_name: "P",
        username: "shradesh-9@mailinator.com",
        email: "shradesh-9@mailinator.com",
      },
      {
        _id: 2223,
        first_name: "Suresh",
        last_name: "Gupta",
        username: "suresh-1@mailinator.com",
        email: "suresh-1@mailinator.com",
      },
    ],
  },
  message: "User Data ",
};

export const reportCategoryData = [
  {
    title: "Onboarding Report",
    description: "List of Users with their Onboarding status and progress.",
    role: ["realtor", "manager", "broker"],
    pageName: "/onboarding-report",
  },
  {
    title: "Profile Completion Report",
    description: "List of Users with the status of their Profile completion.",
    role: ["realtor", "manager", "broker"],
    pageName: "/profile-report",
  },
  {
    title: "Action Path Progress",
    description:
      "List of Users undergoing Action Path along with their progress.",
    role: ["realtor", "manager", "broker"],
    pageName: "/lp-report",
  },
  {
    title: "Course Progress",
    description:
      "List of Users undergoing various courses along with their progress.",
    role: ["realtor", "manager", "broker"],
    pageName: "/course-report",
  },
  {
    title: "Code Of Ethics Report",
    description:
      "List of Users with the status and progress of their Code Of Ethics.",
    role: ["realtor", "manager", "broker"],
    pageName: "/codeofethics-report",
  },
  {
    title: "Event Report",
    description:
      "List of Users undergoing various events along with their progress.",
    role: ["realtor", "manager", "broker"],
    pageName: "/event-report",
  },
  {
    title: "Purchase Report",
    description:
      "List of Users who have purchased courses, videos and sessions.",
    role: ["manager", "broker"],
    pageName: "/purchase-report",
  },
  {
    title: "Plan Upgrade",
    description:
      "List of Users who have upgraded their subscription plan to Premium.",
    role: ["manager", "broker"],
    pageName: "/plan-upgrade-report",
  },
];

export const reportButtonsArr = [
  // compliance
  // {
  //   id: 0,
  //   heading: "Generate a Compliance Report",
  //   link: "/compliance-report",
  //   linkMobile: "/compliance-report-mobile",
  //   btnText: "Compliance",
  // },
  // Onboarding
  // {
  //   id: 1,
  //   heading: "Generate an Onboarding Report",
  //   link: "/lp-report",
  //   linkMobile: "/lp-report-mobile",
  //   btnText: "Onboarding",
  // },
  // Action Path
  {
    id: 2,
    heading: "Generate a Action Path Report",
    link: "/lp-report",
    linkMobile: "/lp-report-mobile",
    btnText: "Action Path",
  },
  // Learning Progress report
  {
    id: 4,
    heading: "Generate a Learning Progress Report",
    link: "/compliance-report",
    linkMobile: "/compliance-report-mobile",
    btnText: "Asset Progress",
  },
  // Code of ethics
  // {
  //   id: 5,
  //   heading: "Generate a Code of Ethics Report",
  //   link: "/codeofethics-report",
  //   linkMobile: "/codeofethicsMobile-report",
  //   btnText: "Code Of Ethics",
  // },
  // System Usage Reports
  {
    id: 6,
    heading: "Generate an System Usage Report",
    link: "/systemusage-report",
    linkMobile: "/systemusageMobile-report",
    btnText: "System Usage",
  },
  {
    id: 7,
    heading: "Generate an Assessment Report",
    link: "/assessment-report",
    linkMobile: "/assessmentMobile-report",
    btnText: "Assessment Responses",
  },
];

export const leaderBoardDataTest = [
  {
    user_id: "2256",
    user_points: "2256",
    user_rank: "95",
  },
  {
    user_id: "2245",
    user_points: "2245",
    user_rank: "90",
  },
  {
    user_id: "2231",
    user_points: "2231",
    user_rank: "84",
  },
  {
    user_id: "2272",
    user_points: "2272",
    user_rank: "76",
  },
  {
    user_id: "2260",
    user_points: "2260",
    user_rank: "67",
  },
  {
    user_id: "2342",
    user_points: "2342",
    user_rank: "64",
  },
  {
    user_id: "2433",
    user_points: "2433",
    user_rank: "56",
  },
  {
    user_id: "2434",
    user_points: "2434",
    user_rank: "55",
  },
  {
    user_id: "2343",
    user_points: "2343",
    user_rank: "54",
  },
  {
    user_id: "2273",
    user_points: "2273",
    user_rank: "46",
  },
  {
    user_id: "2135",
    user_points: "2135",
    user_rank: "45",
  },
  {
    user_id: "2129",
    user_points: "2129",
    user_rank: "36",
  },
  {
    user_id: "2225",
    user_points: "2225",
    user_rank: "34",
  },
  {
    user_id: "2432",
    user_points: "2432",
    user_rank: "34",
  },
  {
    user_id: "2251",
    user_points: "2251",
    user_rank: "27",
  },
  {
    user_id: "2261",
    user_points: "2261",
    user_rank: "27",
  },
  {
    user_id: "2318",
    user_points: "2318",
    user_rank: "25",
  },
  {
    user_id: "2267",
    user_points: "2267",
    user_rank: "24",
  },
  {
    user_id: "2200",
    user_points: "2200",
    user_rank: "23",
  },
  {
    user_id: "2224",
    user_points: "2224",
    user_rank: "23",
  },
  {
    user_id: "2226",
    user_points: "2226",
    user_rank: "23",
  },
  {
    user_id: "2320",
    user_points: "2320",
    user_rank: "18",
  },
  {
    user_id: "2247",
    user_points: "2247",
    user_rank: "12",
  },
  {
    user_id: "2248",
    user_points: "2248",
    user_rank: "12",
  },
  {
    user_id: "2186",
    user_points: "2427",
    user_rank: "10",
  },
  {
    user_id: "2185",
    user_points: "2427",
    user_rank: "7",
  },
  {
    user_id: "2143",
    user_points: "2427",
    user_rank: "6",
  },
  {
    user_id: "2130",
    user_points: "2427",
    user_rank: "5",
  },
  {
    user_id: "2131",
    user_points: "2427",
    user_rank: "1",
  },
];

export const levelDetailData = {
  id: "625938",
  user_id: "1847",
  brokerage_id: "510",
  broker_id: "510",
  entity_type: "learningpath",
  start_date: "2022-07-09",
  end_date: "2022-10-17",
  prgm_nm: "LP 1",
  prgm_description:
    "<p>This course provides a practical application of complying with Canada’s Anti-Spam Legislation (CASL).&nbsp;It also covers compliance with CASL when sending commercial electronic messages (CEMs) to an electronic address and compliance with an unsubscribe mechanism.​</p><p><i><strong>Note: </strong>We recommend you also go through the following courses for your better understanding of CASL:</i></p><ul><li><i>Seller Listing Agreement and Seller Customer Service Agreement</i></li><li><i>Buyer Representation and Customer Service Forms</i></li><li><i>Marketing Strategies/Advertising</i></li></ul>",
  provider: {
    provider_id: "302",
    provider_display_name: "dk-test2",
    provider_name: "dk-test2",
    provider_img:
      "https://admin.financialwellness.envision.pwc.com/wp-content/uploads/2022/08/logoimages-1.png",
  },
  source: "broker",
  thumbnail:
    "https://admin.financialwellness.envision.pwc.com/wp-content/uploads/2022/07/1657401175-wstcoursethumb.png",
  prgm_progress: 100,
  course_count: 1,
  program_days: "100",
  coursesList: [
    {
      wc_post_id: "62486",
      prgm_nm: "",
      crscd: "dk-GOHGX8X",
      course_module_dec: null,
      is_course: false,
      market_price: "",
      selling_price: "",
      discount: "",
      typ: "539",
      provider: {
        provider_id: "302",
        provider_display_name: "dk-test2",
        provider_name: "dk-test2",
        provider_img:
          "https://admin.financialwellness.envision.pwc.com/wp-content/uploads/2022/08/logoimages-1.png",
      },
      source: "broker",
      ttlTime: "",
      banner:
        "https://admin.financialwellness.envision.pwc.com/wp-content/uploads/2022/07/1657400308-wstsplash.png",
      resources_data: null,
      partner: false,
      sfdc_id: "",
      id: "62486",
      crs_progress: 100,
      isAssigned: false,
      views: 2,
      name: "LP 1 Course 1",
      imageURL:
        "https://admin.financialwellness.envision.pwc.com/wp-content/uploads/2022/07/1657400308-wstcoursethumb.png",
      launch_url: "https://financialwellness.envision.pwc.com/courseModuleListing",
      course_categoryId: "",
      isPremium: "Basic",
      start_date: "2022-07-09",
      end_date: "2023-01-25",
      is_paid: true,
      product_type: "",
      lessons: 1,
      duration: "1",
      durationUnit: "minutes",
      assignedByManager: true,
      link: "",
      created_date: "2022-07-09 20:58:28",
      due_date: "01/25/2023",
      assigned_date: "2022-07-09",
      isOverDue: false,
      status: "completed",
      assigned_by: "",
    },
  ],
  status: "completed",
  assigned_by: "",
};

export const levelListData = [
  {
    programID: 626521,

    prgm_nm: "New LP 14-11",

    program_days: 20,

    status: true,

    is_onboarding: true,

    prgm_description: "<p>Desc</p>",

    end_date: "2022-12-04",

    progressstatus: "start",

    prgm_progress: 35,

    coursesList: [
      {
        prgm_nm: "New LP 14-11",

        crscd: "dk-GOHGX8X",

        subscription_type: "Premium",

        typ: "539",

        course_module_dec: "",

        provider: {
          provider_id: "302",

          provider_display_name: "dk-test2",

          provider_name: "dk-test2",

          provider_img:
            "https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/2022/08/logo-search-grid-1x.png",
        },

        banner:
          "https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/2022/07/1657400308-wstsplash.png",

        resources: "",

        id: 62486,

        crs_progress: 45,

        name: "LP 1 Course 1",

        description: "Course 1 for Action Path 1",

        imageURL:
          "https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/2022/07/1657400308-wstcoursethumb.png",

        launch_url:
          "https://realtorsuccesslearning-dev.niit-mts.com/courseModuleListing",

        course_categoryId: null,

        isPremium: false,

        crs_status: true,

        crs_res_points: 0,

        lessons: 1,

        duration: 1,

        durationUnit: "minutes",

        created_date: "2022-07-09 20:58:28",

        is_level: false,

        source: "broker",

        views: 8,

        course_days: 200,
      },

      {
        prgm_nm: "New LP 14-11",

        crscd: "8YIDMFN",

        subscription_type: null,

        typ: "e-Learning",

        course_module_dec: "",

        provider: "/wp-content/uploads/2022/10/xselonboardlogo.png",

        banner: "",

        resources: "",

        id: 857,

        crs_progress: 0,

        name: "Canada’s Anti-Spam Legislation (CASL)",

        description:
          "<p>This course provides a practical application of complying with Canada’s Anti-Spam Legislation (CASL).&nbsp;It also covers compliance with CASL when sending commercial electronic messages (CEMs) to an electronic address and compliance with an unsubscribe mechanism.​</p><p><i><strong>Note: </strong>We recommend you also go through the following courses for your better understanding of CASL:</i></p><ul><li><i>Seller Listing Agreement and Seller Customer Service Agreement</i></li><li><i>Buyer Representation and Customer Service Forms</i></li><li><i>Marketing Strategies/Advertising</i></li></ul>",

        imageURL:
          "https://rsplearning-dev.niit-mts.com/meeting/images/5210327456791863.png",

        launch_url:
          "https://realtorsuccesslearning-dev.niit-mts.com/courseModuleListing",

        course_categoryId: null,

        isPremium: false,

        crs_status: false,

        crs_res_points: 0,

        lessons: 5,

        duration: 20,

        durationUnit: "Minutes",

        created_date: "2022-06-08 21:14:11",

        source: "xsel",

        is_level: false,

        views: 0,

        course_days: 365,
      },

      {
        prgm_nm: "New LP 14-11",

        crscd: "G6WUN2H",

        subscription_type: null,

        typ: "e-Learning",

        course_module_dec: "",

        provider: "/wp-content/uploads/2022/10/xselonboardlogo.png",

        banner: "",

        resources: "",

        prgm_id: 626521,
        id: 1015,

        crs_progress: 0,

        name: "Privacy Act and PIPEDA",

        description:
          "This course covers the practical application of the Canadian Privacy Act and the Personal Information Protection and Electronic Documents Act (PIPEDA) when conducting Real Estate transactions. It also covers the importance and application of the Privacy Legislation while maintaining records of consumers’ personal information.\r\n\r\n<i><strong>Note:</strong> We recommend you also go through the following for your better understanding of Privacy Act and PIPEDA:</i>​\r\n<ul>\r\n \t<li><i>Seller Listing Agreement and Seller Customer Service Agreement</i>​</li>\r\n \t<li><i>Buyer Representation and Customer Service Forms</i>​</li>\r\n \t<li><i>Marketing Strategies/Advertising</i>​</li>\r\n \t<li><i>Agreements of Purchase and Sale</i></li>\r\n</ul>",

        imageURL:
          "https://rsplearning-dev.niit-mts.com/meeting/images/355397718017558.png",

        launch_url:
          "https://realtorsuccesslearning-dev.niit-mts.com/courseModuleListing",

        course_categoryId: null,

        isPremium: false,

        crs_status: false,

        crs_res_points: 0,

        lessons: 5,

        duration: 35,

        durationUnit: "Minutes",

        created_date: "2022-06-21 10:09:11",

        source: "xsel",

        is_level: true,

        views: 0,

        course_days: 20,
      },
    ],

    provider: {
      provider_id: "302",

      provider_display_name: "dk-test2",

      provider_name: "dk-test2",

      provider_img:
        "https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/2022/08/logo-search-grid-1x.png",
    },
  },
];

export const joyRideSteps = [
  {
    content: (
      <p>
        The Tour Guide will help you to understand the features of the platform.
        Click Next to start a quick tour.
      </p>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    placement: "center",
    target: "body",
  },
  {
    target: "#idMyAccountWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Account</h6>,
    content: "Your Profile details will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idUpgradeToPremiumWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Upgrade to Premium</h6>,
    content: "You can upgrade your account from Basic to Premium.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRewardPointsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Reward Points</h6>,
    content:
      "You will earn reward points based on purchases made on the platform. You will be able to use these points for buying further paid services on the platform. You can view your reward points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idOrdersWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Orders</h6>,
    content: "You can view your purchase history details here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idWishListWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Wishlist</h6>,
    content:
      "You can view all the Products which you are added in Wishlist bucket.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idChangePasswordWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Change Password</h6>,
    content: "You can change the password of your account.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCoursesWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Course</h6>,
    content: "You can view the courses categories-wise here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCourseCat",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course Category</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view all the courses under that category. You can filter, search
        and sort the courses.
        <br />
        <b>Click any one category below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idCourseList",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view the course details with the list of modules.
        <br />
        <b>Click any one course below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idModuleDetail",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Module</h6>,
    content:
      'You can view the list of the modules under the selected course here . You can view the "Congratulations" message after the completing all the modules of the course.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idVideosMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Video</h6>,
    content:
      "You can view the video categories and the list of videos comes under each category here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Role Play</h6>,
    content:
      "You can View the participation summary, review and Submission status here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayExplore",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Explore More in Role Play</h6>,
    content:
      'You can select the videos for Role Play "Explore More" Option and assign it to yourself.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCertificationsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Certification</h6>,
    content: "You can view the list of certification programmes here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Events</h6>,
    content:
      'You can view the events list and sessions as well here. If there is no sessions in the events, you can view the "Notify Me" option.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventListing",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Event Card</h6>,
    content:
      "You can view the description of the events and the session list. You can register yourself for a session here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMoreMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>More</h6>,
    content: "You can view additional menu.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idtoolboxWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Tool Box</h6>,
    content:
      "You can Upload, View, Edit and Download all your pdf documents and resources.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idrole-requestWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Network</h6>,
    content:
      "You can view all User Request and checklist approval for the courses if you are a Manager/Admin.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-onboardingWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Onboarding</h6>,
    content: "You can view your Onboarding Action Path here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pathWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Action Path</h6>,
    content:
      'You can view all the Assigned and Un-Assigned Action Paths in Assigned Tab and "Explore More" Tab.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idcoursesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Courses</h6>,
    content:
      "You can view all the Assigned courses here. You can filter the course with status wise here as per your requirement.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idvideosWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Videos</h6>,
    content:
      "All the Self Assigned videos and the videos Assigned by Manager/Brokerage Admin will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#ideventsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Events</h6>,
    content: "You can view all the Purchased Events and Broker Events here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-certificatesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Certificates</h6>,
    content:
      "After completing the Onboarding & Action Path, you can view your certificates here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-badgesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Badges</h6>,
    content:
      "After completing the purchased course, you can view the Badges here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pointsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Learning Points</h6>,
    content: "You can view all the earned Learning Points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCalendarMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Calendar</h6>,
    content:
      "You will get the notification through email after the session registration. All the sessions registered will be displayed on your calendar.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idNotificationMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Bell Notification</h6>,
    content: "You will view all the notifications here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idSearchMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Global Search</h6>,
    content: "You can search for any features from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idLiveBtnMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Live Button</h6>,
    content:
      "You can join for the session you have registered from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMyWall",
    placement: "top,",
    title: <h6 style={{ fontWeight: "700" }}>My Wall</h6>,
    content:
      "You can view your colleagues post in this wall section. You can also post, like and comment on the feeds.",
  },
];

export const joyRideStepsPremium = [
  {
    content: (
      <p>
        The Tour Guide will help you to understand the features of the platform.
        Click Next to start a quick tour.
      </p>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    placement: "center",
    target: "body",
  },
  {
    target: "#idMyAccountWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Account</h6>,
    content: "Your Profile details will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRewardPointsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Reward Points</h6>,
    content:
      "You will earn reward points based on purchases made on the platform. You will be able to use these points for buying further paid services on the platform. You can view your reward points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idOrdersWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Orders</h6>,
    content: "You can view your purchase history details here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idWishListWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Wishlist</h6>,
    content:
      "You can view all the Products which you are added in Wishlist bucket.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idChangePasswordWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Change Password</h6>,
    content: "You can change the password of your account.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCoursesWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Course</h6>,
    content: "You can view the courses categories-wise here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCourseCat",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course Category</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view all the courses under that category. You can filter, search
        and sort the courses.
        <br />
        <b>Click any one category below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idCourseList",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view the course details with the list of modules.
        <br />
        <b>Click any one course below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idModuleDetail",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Module</h6>,
    content:
      'You can view the list of the modules under the selected course here . You can view the "Congratulations" message after the completing all the modules of the course.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idVideosMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Video</h6>,
    content:
      "You can view the video categories and the list of videos comes under each category here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Role Play</h6>,
    content:
      "You can View the participation summary, review and Submission status here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayExplore",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Explore More in Role Play</h6>,
    content:
      'You can select the videos for Role Play "Explore More" Option and assign it to yourself.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCertificationsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Certification</h6>,
    content: "You can view the list of certification programmes here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Events</h6>,
    content:
      'You can view the events list and sessions as well here. If there is no sessions in the events, you can view the "Notify Me" option.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventListing",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Event Card</h6>,
    content:
      "You can view the description of the events and the session list. You can register yourself for a session here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMoreMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>More</h6>,
    content: "You can view additional menu.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idtoolboxWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Tool Box</h6>,
    content:
      "You can Upload, View, Edit and Download all your pdf documents and resources.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idrole-requestWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Network</h6>,
    content:
      "You can view all User Request and checklist approval for the courses if you are a Manager/Admin.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-onboardingWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Onboarding</h6>,
    content: "You can view your Onboarding Action Path here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pathWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Action Path</h6>,
    content:
      'You can view all the Assigned and Un-Assigned Action Paths in Assigned Tab and "Explore More" Tab.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idcoursesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Courses</h6>,
    content:
      "You can view all the Assigned courses here. You can filter the course with status wise here as per your requirement.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idvideosWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Videos</h6>,
    content:
      "All the Self Assigned videos and the videos Assigned by Manager/Brokerage Admin will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#ideventsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Events</h6>,
    content: "You can view all the Purchased Events and Broker Events here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-certificatesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Certificates</h6>,
    content:
      "After completing the Onboarding & Action Path, you can view your certificates here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-badgesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Badges</h6>,
    content:
      "After completing the purchased course, you can view the Badges here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pointsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Learning Points</h6>,
    content: "You can view all the earned Learning Points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCalendarMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Calendar</h6>,
    content:
      "You will get the notification through email after the session registration. All the sessions registered will be displayed on your calendar.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idNotificationMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Bell Notification</h6>,
    content: "You will view all the notifications here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idSearchMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Global Search</h6>,
    content: "You can search for any features from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idLiveBtnMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Live Button</h6>,
    content:
      "You can join for the session you have registered from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMyWall",
    placement: "top,",
    title: <h6 style={{ fontWeight: "700" }}>My Wall</h6>,
    content:
      "You can view your colleagues post in this wall section. You can also post, like and comment on the feeds.",
  },
];

export const joyRideStepsManager = [
  {
    content: (
      <p>
        The Tour Guide will help you to understand the features of the platform.
        Click Next to start a quick tour.
      </p>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    placement: "center",
    target: "body",
  },
  {
    target: "#idMyAccountMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Account</h6>,
    content: "Your Profile details will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idUpgradeToPremiumMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Upgrade to Premium</h6>,
    content: "You can upgrade your account from Basic to Premium.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRewardPointsMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Reward Points</h6>,
    content:
      "You will earn reward points based on purchases made on the platform. You will be able to use these points for buying further paid services on the platform. You can view your reward points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idOrdersMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Orders</h6>,
    content: "You can view your purchase history details here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idWishListMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Wishlist</h6>,
    content:
      "You can view all the Products which you are added in Wishlist bucket.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },

  {
    target: "#idChangePasswordMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Change Password</h6>,
    content: "You can change the password of your account",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCoursesWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Course</h6>,
    content: "You can view the courses categories-wise here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCourseCat",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course Category</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view all the courses under that category. You can filter, search
        and sort the courses.
        <br />
        <b>Click any one category below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idCourseList",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view the course details with the list of modules.
        <br />
        <b>Click any one course below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idModuleDetail",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Module</h6>,
    content:
      'You can view the list of the modules under the selected course here . You can view the "Congratulations" message after the completing all the modules of the course.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idVideosMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Video</h6>,
    content:
      "You can view the video categories and the list of videos comes under each category here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Role Play</h6>,
    content:
      "You can View the participation summary, review and Submission status here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayExplore",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Explore More in Role Play</h6>,
    content:
      'You can select the videos for Role Play "Explore More" Option and assign it to yourself.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCertificationsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Certification</h6>,
    content: "You can view the list of certification programmes here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Events</h6>,
    content:
      'You can view the events list and sessions as well here. If there is no sessions in the events, you can view the "Notify Me" option.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventListing",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Event Card</h6>,
    content:
      "You can view the description of the events and the session list. You can register yourself for a session here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMoreMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>More</h6>,
    content: "You can view additional menu.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idreportWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Reports</h6>,
    content: "You can view and download user reports here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idtoolboxWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Tool Box</h6>,
    content:
      "You can Upload, View, Edit and Download all your pdf documents and resources.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idrole-requestWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Network</h6>,
    content:
      "You can view all User Request and checklist approval for the courses if you are a Manager/Admin.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-onboardingWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Onboarding</h6>,
    content: "You can view your Onboarding Action Path here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pathWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Action Path</h6>,
    content:
      'You can view all the Assigned and Un-Assigned Action Paths in Assigned Tab and "Explore More" Tab.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idcoursesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Courses</h6>,
    content:
      "You can view all the Assigned courses here. You can filter the course with status wise here as per your requirement.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idvideosWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Videos</h6>,
    content:
      "All the Self Assigned videos and the videos Assigned by Manager/Brokerage Admin will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#ideventsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Events</h6>,
    content: "You can view all the Purchased Events and Broker Events here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-certificatesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Certificates</h6>,
    content:
      "After completing the Onboarding & Action Path, you can view your certificates here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-badgesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Badges</h6>,
    content:
      "After completing the purchased course, you can view the Badges here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pointsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Learning Points</h6>,
    content: "You can view all the earned Learning Points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCalendarMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Calendar</h6>,
    content:
      "You will get the notification through email after the session registration. All the sessions registered will be displayed on your calendar.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idNotificationMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Bell Notification</h6>,
    content: "You will view all the notifications here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idSearchMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Global Search</h6>,
    content: "You can search for any features from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idLiveBtnMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Live Button</h6>,
    content:
      "You can join for the session you have registered from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMyWall",
    placement: "top,",
    title: <h6 style={{ fontWeight: "700" }}>My Wall</h6>,
    content:
      "You can view your colleagues post in this wall section. You can also post, like and comment on the feeds.",
  },
];

export const joyRideStepsManagerPremium = [
  {
    content: (
      <p>
        The Tour Guide will help you to understand the features of the platform.
        Click Next to start a quick tour.
      </p>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    placement: "center",
    target: "body",
  },
  {
    target: "#idMyAccountMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Account</h6>,
    content: "Your Profile details will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRewardPointsMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Reward Points</h6>,
    content:
      "You will earn reward points based on purchases made on the platform. You will be able to use these points for buying further paid services on the platform. You can view your reward points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idOrdersMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Orders</h6>,
    content: "You can view your purchase history details here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idWishListMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Wishlist</h6>,
    content:
      "You can view all the Products which you are added in Wishlist bucket.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idChangePasswordMngWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Change Password</h6>,
    content: "You can change the password of your account",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCoursesWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Course</h6>,
    content: "You can view the courses categories-wise here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCourseCat",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course Category</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view all the courses under that category. You can filter, search
        and sort the courses.
        <br />
        <b>Click any one category below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idCourseList",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Course</h6>,
    spotlightClicks: true,
    content: (
      <div>
        You can view the course details with the list of modules.
        <br />
        <b>Click any one course below!</b>
      </div>
    ),
    locale: { skip: <strong aria-label="skip">Skip</strong> },
    styles: {
      buttonNext: {
        display: "none",
      },
      buttonBack: {
        display: "none",
      },
    },
  },
  {
    target: "#idModuleDetail",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Select Module</h6>,
    content:
      'You can view the list of the modules under the selected course here . You can view the "Congratulations" message after the completing all the modules of the course.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idVideosMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Video</h6>,
    content:
      "You can view the video categories and the list of videos comes under each category here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayMenuWeb",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Role Play</h6>,
    content:
      "You can View the participation summary, review and Submission status here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idRolePlayExplore",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Explore More in Role Play</h6>,
    content:
      'You can select the videos for Role Play "Explore More" Option and assign it to yourself.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCertificationsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Certification</h6>,
    content: "You can view the list of certification programmes here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventsMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Events</h6>,
    content:
      'You can view the events list and sessions as well here. If there is no sessions in the events, you can view the "Notify Me" option.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idEventListing",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Event Card</h6>,
    content:
      "You can view the description of the events and the session list. You can register yourself for a session here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMoreMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>More</h6>,
    content: "You can view additional menu.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idreportWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Reports</h6>,
    content: "You can view and download user reports here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idtoolboxWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Tool Box</h6>,
    content:
      "You can Upload, View, Edit and Download all your pdf documents and resources.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idrole-requestWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Network</h6>,
    content:
      "You can view all User Request and checklist approval for the courses if you are a Manager/Admin.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-onboardingWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Onboarding</h6>,
    content: "You can view your Onboarding Action Path here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pathWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Action Path</h6>,
    content:
      'You can view all the Assigned and Un-Assigned Action Paths in Assigned Tab and "Explore More" Tab.',
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idcoursesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Courses</h6>,
    content:
      "You can view all the Assigned courses here. You can filter the course with status wise here as per your requirement.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idvideosWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Videos</h6>,
    content:
      "All the Self Assigned videos and the videos Assigned by Manager/Brokerage Admin will display here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#ideventsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Events</h6>,
    content: "You can view all the Purchased Events and Broker Events here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-certificatesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>My Certificates</h6>,
    content:
      "After completing the Onboarding & Action Path, you can view your certificates here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idmy-badgesWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Badges</h6>,
    content:
      "After completing the purchased course, you can view the Badges here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idlearning-pointsWeb",
    placement: "left",
    title: <h6 style={{ fontWeight: "700" }}>Learning Points</h6>,
    content: "You can view all the earned Learning Points here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idCalendarMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Calendar</h6>,
    content:
      "You will get the notification through email after the session registration. All the sessions registered will be displayed on your calendar.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idNotificationMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Bell Notification</h6>,
    content: "You will view all the notifications here.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idSearchMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Global Search</h6>,
    content: "You can search for any features from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idLiveBtnMenu",
    placement: "bottom",
    title: <h6 style={{ fontWeight: "700" }}>Live Button</h6>,
    content:
      "You can join for the session you have registered from this option.",
    locale: { skip: <strong aria-label="skip">Skip</strong> },
  },
  {
    target: "#idMyWall",
    placement: "top,",
    title: <h6 style={{ fontWeight: "700" }}>My Wall</h6>,
    content:
      "You can view your colleagues post in this wall section. You can also post, like and comment on the feeds.",
  },
];
